import * as Yup from "yup";

export const projectValidation = Yup.object({
  name: Yup.string().required("Title is required"),
  description: Yup.string().required("Description is required"),
  clientName: Yup.string().optional(),
  status: Yup.string().optional(),
});
